import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export function PortalPage({ title, subtitle, actions, back, children, testid }) {
  return (
    <div className="max-w-7xl mx-auto animate-fade-in" data-testid={testid}>
      {back && (
        <Link to={back.to} className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-primary mb-3" data-testid="portal-back-link">
          <ArrowLeft size={14} /> {back.label || "Back"}
        </Link>
      )}
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-6">
        <div className="min-w-0">
          <h1 className="text-2xl sm:text-3xl font-bold font-[Chivo] tracking-tight" data-testid="portal-page-title">{title}</h1>
          {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0 flex-wrap">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export function Pill({ map, value, className = "" }) {
  const cfg = map[value] || { label: (value || "").replace(/_/g, " "), cls: "bg-slate-100 text-slate-700" };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium whitespace-nowrap ${cfg.cls} ${className}`}>{cfg.label}</span>;
}

export function EmptyState({ icon: Icon, title, text, action }) {
  return (
    <div className="border border-dashed border-border rounded-lg py-14 text-center" data-testid="portal-empty-state">
      {Icon && <Icon size={36} className="mx-auto text-muted-foreground/40 mb-3" weight="duotone" />}
      <p className="text-sm font-semibold">{title}</p>
      {text && <p className="text-xs text-muted-foreground mt-1 max-w-sm mx-auto">{text}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, color = "text-primary", href, testid, sub }) {
  const body = (
    <div className={`border border-border rounded-md p-4 bg-card h-full ${href ? "card-lift hover:border-primary/40 cursor-pointer group" : ""}`} data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-[10px] uppercase tracking-[0.15em] font-semibold text-muted-foreground">{label}</span>
        {Icon && <Icon size={18} className={`${color} ${href ? "group-hover:scale-110 transition-transform" : ""}`} weight="duotone" />}
      </div>
      <p className="text-2xl font-bold font-[Chivo] tracking-tight">{value}</p>
      {sub && <p className="text-[11px] text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
  return href ? <Link to={href} className="block h-full">{body}</Link> : body;
}

export function Section({ title, action, children, className = "", testid }) {
  return (
    <div className={`border border-border rounded-lg bg-card ${className}`} data-testid={testid}>
      {(title || action) && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h2 className="text-sm font-semibold font-[Chivo]">{title}</h2>
          {action}
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <div className="space-y-1.5">
      <label className="text-xs font-medium text-muted-foreground">{label}</label>
      {children}
      {hint && <p className="text-[11px] text-muted-foreground">{hint}</p>}
    </div>
  );
}
